import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { MainButton } from 'components/button'
import { localize } from 'helpers/translator'

import styles from './alert.scss'


class Alert extends Component {

	constructor() {
		super()

		this.state = {
			disabled: false,
		}
	}

	render() {

		const buttons = this.props.buttons.map((button, index) => {

			if (button.callback === undefined) {
				if (this.props.closeOnAction === false) {
					button.callback = () => this.props.onAlertClose(this.props.alertId)
				} else {
					button.callback = () => {}
				}
			}

			return (
				<div key={index} styleName={classNames({
					alert_modal_button: true,
					alert_modal_button_single: this.props.singleButton,
				})}>
					<MainButton
						disabled={this.state.disabled}
						onClick={
							() => {
								this.setState({
									disabled: true,
								})
								if (this.props.closeOnAction === true) {
									this.props.onAlertClose(this.props.alertId)
								}
								button.callback()
							}}
					>
						{localize(button.buttonName)}
					</MainButton>
				</div>
			)
		})

		return (
			<div styleName='alert_modal_main'>
				<div styleName='alert_modal_opacity'></div>
				<div styleName='alert_modal'>
					<div styleName='alert_modal_content'>
						<i styleName='alert_modal_close' onClick={() => this.props.onAlertClose(this.props.alertId)}>close</i>
						<h2 styleName='alert_modal_content_title'>{localize(this.props.alertTitle)}</h2>
						<p styleName='alert_modal_content_subtitle'>{localize(this.props.alertMessage)}</p>
						<div styleName='alert_modal_content_buttons-area'>
							{buttons}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

Alert.defaultProps = {
	closeOnAction: false,
	singleButton: false,
}

Alert.propTypes = {
	buttons: PropTypes.array,
	onAlertClose: PropTypes.func,
	alertTitle: PropTypes.string,
	alertMessage: PropTypes.string,
	alertId: PropTypes.number,
	closeOnAction: PropTypes.bool,
	singleButton: PropTypes.bool,
}

export default CSSModules(Alert, styles, {allowMultiple: true})
